// extracted by mini-css-extract-plugin
export default {"title":"CompanyInformation_title__QJ+Nc","group":"CompanyInformation_group__JbFLc","field":"CompanyInformation_field__JNCx8"};